import NavbarInstitut from '../../../components/feature/NavbarInstitut';
import FooterInstitut from '@/components/feature/FooterInstitut';
import { BG_IMAGES } from '@/config/bg';
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function InstitutOrientationPage() {
  const [activeTab, setActiveTab] = useState('juridique');

  const departements = {
    juridique: {
      nom: "Sciences Juridiques Administratives et Politiques",
      description: "Formation complète explorant les divers domaines du droit : civil, pénal, administratif, constitutionnel et international. Les étudiants développent une compréhension approfondie des normes juridiques, procédures judiciaires et principes fondamentaux du système légal.",
      competences: [
        "Analyse et rédaction juridique",
        "Procédures judiciaires et administratives",
        "Négociation et médiation",
        "Droit comparé et international",
        "Éthique et déontologie professionnelle"
      ],
      debouches: [
        { nom: "Avocat", icon: "ri-scale-3-line" },
        { nom: "Juriste d'entreprise", icon: "ri-building-line" },
        { nom: "Magistrat", icon: "ri-gavel-line" },
        { nom: "Analyste politique", icon: "ri-government-line" },
        { nom: "Consultant en relations publiques", icon: "ri-megaphone-line" }
      ],
      parcours: ["Droit Public", "Droit Privé", "Droit International", "Carrières Judiciaires"]
    },
    informatique: {
      nom: "Sciences de l'Informatique",
      description: "Programme complet explorant la programmation, bases de données, réseaux, intelligence artificielle et cybersécurité. Formation pratique intensive avec projets concrets et travaux en laboratoire sur technologies actuelles.",
      competences: [
        "Développement web et mobile",
        "Conception de bases de données",
        "Administration réseaux et sécurité",
        "Intelligence artificielle et machine learning",
        "Gestion de projet agile"
      ],
      debouches: [
        { nom: "Développeur Web & Mobile", icon: "ri-code-s-slash-line" },
        { nom: "Analyste-Programmeur", icon: "ri-terminal-line" },
        { nom: "Consultant IT", icon: "ri-computer-line" },
        { nom: "Testeur Logiciel", icon: "ri-bug-line" },
        { nom: "Développeur IA", icon: "ri-brain-line" }
      ],
      parcours: ["Génie Logiciel", "Data Science", "Cybersécurité", "Intelligence Artificielle"]
    },
    economique: {
      nom: "Sciences Économiques et de Gestion",
      description: "Formation complète en économie, management, finance, comptabilité et marketing digital. Compréhension des mécanismes économiques, stratégies d'entreprise et principes fondamentaux du monde des affaires.",
      competences: [
        "Analyse économique et financière",
        "Gestion comptable et audit",
        "Stratégies marketing digital",
        "Management et leadership",
        "Économétrie et modélisation"
      ],
      debouches: [
        { nom: "Analyste Financier", icon: "ri-line-chart-line" },
        { nom: "Expert-Comptable", icon: "ri-calculator-line" },
        { nom: "Auditeur", icon: "ri-file-search-line" },
        { nom: "Expert Marketing Digital", icon: "ri-megaphone-line" },
        { nom: "Gestionnaire PME", icon: "ri-building-2-line" }
      ],
      parcours: ["Finance-Comptabilité", "Marketing Digital", "Gestion d'Entreprise", "Économie Appliquée"]
    }
  };

  const departement = departements[activeTab];

  return (
    <div className="min-h-screen bg-white">
      <NavbarInstitut />

      {/* Header */}
      <div className="relative mb-12">
        <div
          className="relative h-64 pt-24 sm:h-96 overflow-hidden bg-cover bg-center"
          style={{ backgroundImage: `url(${BG_IMAGES.institut})` }}
          data-aos="fade-up"
        >
          <div className="absolute inset-0 bg-black/50"></div>
          <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-2 text-white" style={{ fontFamily: 'Playfair Display, serif' }}>
              ORIENTATION — INSTITUT UNIVERSITAIRE FRED & POPPEE
            </h1>
            <p className="text-lg text-white/90 max-w-3xl mx-auto">Choisissez votre parcours académique et découvrez vos perspectives professionnelles</p>
          </div>
        </div>
      </div>

      {/* Contenu */}
      <div className="pt-8 pb-20 px-5">
        <div className="max-w-7xl mx-auto">
          {/* Tabs Navigation */}
          <div className="flex flex-wrap justify-center gap-4 mb-12" data-aos="fade-up">
            <button
              onClick={() => setActiveTab('juridique')}
              className={`px-6 py-3 rounded-lg font-semibold transition-all ${activeTab === 'juridique' ? 'bg-[#ff7b22] text-white shadow-lg' : 'bg-blue-50 text-gray-700 hover:bg-green-100'}`}
            >
              <i className="ri-scales-3-line mr-2"></i>
              Sciences Juridiques
            </button>
            <button
              onClick={() => setActiveTab('informatique')}
              className={`px-6 py-3 rounded-lg font-semibold transition-all ${activeTab === 'informatique' ? 'bg-[#ff7b22] text-white shadow-lg' : 'bg-purple-50 text-gray-700 hover:bg-green-100'}`}
            >
              <i className="ri-cpu-line mr-2"></i>
              Informatique
            </button>
            <button
              onClick={() => setActiveTab('economique')}
              className={`px-6 py-3 rounded-lg font-semibold transition-all ${activeTab === 'economique' ? 'bg-[#ff7b22] text-white shadow-lg' : 'bg-green-50 text-gray-700 hover:bg-green-100'}`}
            >
              <i className="ri-line-chart-line mr-2"></i>
              Sciences Économiques
            </button>
          </div>

          {/* Contenu du département actif */}
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden" data-aos="fade-up">
            {/* En-tête */}
            <div className={`p-8 ${activeTab === 'juridique' ? 'bg-blue-50' : activeTab === 'informatique' ? 'bg-purple-50' : 'bg-green-50'}`}>
              <div className="flex items-center gap-4">
                <div className={`w-20 h-20 rounded-2xl flex items-center justify-center ${activeTab === 'juridique' ? 'bg-blue-100 text-blue-600' : activeTab === 'informatique' ? 'bg-purple-100 text-purple-600' : 'bg-green-100 text-[#ff7b22]'}`}>
                  <i className={`${activeTab === 'juridique' ? 'ri-scales-3-line' : activeTab === 'informatique' ? 'ri-cpu-line' : 'ri-line-chart-line'} text-3xl`}></i>
                </div>
                <div>
                  <h2 className="text-3xl font-bold text-gray-900">{departement.nom}</h2>
                  <p className="text-gray-600 mt-2">Découvrez le programme, compétences et débouchés</p>
                </div>
              </div>
            </div>

            {/* Contenu principal */}
            <div className="p-8">
              <div className="grid lg:grid-cols-3 gap-8">
                {/* Description */}
                <div className="lg:col-span-2">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">Description du programme</h3>
                  <p className="text-gray-700 text-lg mb-8">{departement.description}</p>

                  <div className="mb-8">
                    <h4 className="text-xl font-bold text-gray-900 mb-4">Parcours proposés</h4>
                    <div className="flex flex-wrap gap-3">
                      {departement.parcours.map((parcours, idx) => (
                        <span key={idx} className="px-4 py-2 bg-gray-100 text-gray-800 rounded-full font-medium">
                          {parcours}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div>
                    <h4 className="text-xl font-bold text-gray-900 mb-4">Compétences développées</h4>
                    <ul className="grid sm:grid-cols-2 gap-3">
                      {departement.competences.map((competence, idx) => (
                        <li key={idx} className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
                          <i className="ri-check-line text-[#ff7b22]"></i>
                          <span className="text-gray-800">{competence}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* Débouchés */}
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-6">Débouchés professionnels</h3>
                  <div className="space-y-4">
                    {departement.debouches.map((debouche, idx) => (
                      <div key={idx} className="flex items-center gap-4 p-4 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors">
                        <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${activeTab === 'juridique' ? 'bg-blue-100 text-blue-600' : activeTab === 'informatique' ? 'bg-purple-100 text-purple-600' : 'bg-green-100 text-[#ff7b22]'}`}>
                          <i className={debouche.icon}></i>
                        </div>
                        <div>
                          <h5 className="font-bold text-gray-900">{debouche.nom}</h5>
                          <p className="text-gray-600 text-sm">Perspective professionnelle</p>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="mt-8 p-6 bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl">
                    <h4 className="font-bold text-gray-900 mb-2">Besoin d'aide pour choisir ?</h4>
                    <p className="text-gray-700 text-sm mb-4">Notre service d'orientation est à votre disposition</p>
                    <a
                      href="#"
                      className="inline-flex items-center gap-2 px-4 py-2 bg-white text-blue-600 rounded-lg font-semibold hover:shadow transition-all"
                    >
                      <i className="ri-calendar-line"></i>
                      Prendre rendez-vous
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Vie étudiante */}
          <div className="mt-16" data-aos="fade-up">
            <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">Vie étudiante et activités</h3>
            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-gradient-to-r from-orange-50 to-red-50 rounded-2xl p-8">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-16 h-16 rounded-xl bg-orange-100 flex items-center justify-center text-orange-600">
                    <i className="ri-football-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="text-2xl font-bold text-gray-900">Association Sportive</h4>
                    <p className="text-gray-700">Football et Basketball</p>
                  </div>
                </div>
                <p className="text-gray-700 mb-4">
                  Participez à nos équipes sportives universitaires et représentiez l'institut lors des compétitions inter-universitaires.
                </p>
                <Link to="/institut/association-sportive" className="inline-flex items-center gap-2 text-orange-600 font-semibold">
                  Voir le calendrier sportif <i className="ri-arrow-right-line"></i>
                </Link>
              </div>

              <div className="bg-gradient-to-r from-green-50 to-teal-50 rounded-2xl p-8">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-16 h-16 rounded-xl bg-green-100 flex items-center justify-center text-[#ff7b22]">
                    <i className="ri-bus-2-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="text-2xl font-bold text-gray-900">Activités extrascolaires</h4>
                    <p className="text-gray-700">Sorties & Excursions</p>
                  </div>
                </div>
                <p className="text-gray-700 mb-4">
                  Découvrez des activités culturelles, visites d'entreprises et excursions éducatives pour enrichir votre expérience universitaire.
                </p>
                <Link to="/institut/activites-extra-universitaires" className="inline-flex items-center gap-2 text-[#ff7b22] font-semibold">
                  Voir les prochaines activités <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </div>

          {/* CTA final */}
          <div className="mt-16 text-center" data-aos="fade-up">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Prêt à rejoindre notre communauté ?</h3>
            <p className="text-gray-700 mb-8 max-w-2xl mx-auto">
              Contactez notre service des admissions pour plus d'informations sur les modalités d'inscription.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link
                to="/institut/contact"
                className="inline-flex items-center gap-3 px-8 py-4 bg-[#ff7b22] text-white rounded-xl font-bold hover:bg-green-700 transition-colors"
              >
                <i className="ri-mail-line"></i>
                Contacter les admissions
              </Link>
              {/* <a
                href="#"
                className="inline-flex items-center gap-3 px-8 py-4 border-2 border-blue-600 text-blue-600 rounded-xl font-bold hover:bg-blue-50 transition-colors"
              >
                <i className="ri-download-line"></i>
                Télécharger le guide d'orientation
              </a> */}
            </div>
          </div>
        </div>
      </div>

      <FooterInstitut />
    </div>
  );
}